/**
 * projectScope.js — which projects the outline's home list shows.
 *
 *   'mine'  (default) only the projects with a flight the logged-in person is crewed on
 *   'all'             every active project
 *
 * Decision 10 (docs/FLOW_RECONCILIATION_PLAN.md, 2026-09-02): a person's flights sit pinned above
 * the outline and the outline underneath shows only what those flights belong to — "this keeps
 * everything VERY focused." The toggle on the title line (ZoomTitle) and the /mine and /all
 * commands flip it; the choice persists per browser.
 */

const KEY = 'aj:projects:scope'
let scope = null

export function getProjectScope() {
  if (scope) return scope
  try { scope = localStorage.getItem(KEY) === 'all' ? 'all' : 'mine' } catch { scope = 'mine' }
  return scope
}

export function setProjectScope(next) {
  scope = next === 'all' ? 'all' : 'mine'
  try { localStorage.setItem(KEY, scope) } catch { /* private mode etc. — the in-memory value still applies */ }
  if (typeof window !== 'undefined') window.dispatchEvent(new Event('outline-render'))
  return scope
}

export function toggleProjectScope() {
  return setProjectScope(getProjectScope() === 'mine' ? 'all' : 'mine')
}
